import { Menu } from 'antd';

import { CategoryTopic } from 'src/interface/Auth/Register/RegisterUser';

const DropdownMenu = (props: any) => {
	return (
		<Menu 
			className="mr-[-30px] font-semibold text-neutral-5 rounded-[8px] px-[24px] py-[22px] text-[14px] sm:text-[18px] xl:text-[16px] leading-[24px] bg-[var(--white)] !shadow-[0px_2px_6px_rgba(0,0,0,0.25)] [&_.ant-menu-item-selected]:bg-neutral-17 [&_.ant-menu-item-selected]:rounded-[8px] [&_.ant-menu-item-active]:bg-neutral-17 [&_.ant-menu-item-active]:rounded-[8px]"
			selectedKeys={props.active}
			onClick={props.onChangeFn}
			items={props.menu?.slice(props.keyTopic, 100)?.map((item: CategoryTopic, id: number) => ({
				key: `${id + props.keyTopic + 1}__${item.slug}`,
				label: (
					<a href={item.full_slug}>{item.name}</a>
				)
			}))}
		/>
	);
};

export default DropdownMenu;
